import axios from '../utils/axios';

export default function deleteCENote(adminId, id, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/notes/' + id +  '/delete',  data )
    )
}
